import { Component, OnInit } from "@angular/core";
import { Globals } from "src/app/shared/helpers/globals";
import { UntypedFormBuilder, Validators, ReactiveFormsModule, FormGroup } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { NgIf } from "@angular/common";
import { NgxMaskDirective, provideNgxMask } from "ngx-mask";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "app-ordem",
    templateUrl: "./ordem.component.html",
    styleUrls: ["./ordem.component.css"],
    providers: [provideNgxMask()],
    imports: [MatButtonModule, MatIconModule, RouterLink, ReactiveFormsModule, MatFormFieldModule, MatInputModule, NgxMaskDirective, NgIf]
})
export class OrdemComponent implements OnInit {
  form!: FormGroup;
  tokenIam!: string;

  constructor(
    private router: Router,
    private globals: Globals,
    fb: UntypedFormBuilder
  ) {
    this.form = fb.group({
      nroProcesso: ["", [Validators.minLength(20), Validators.maxLength(20)]]
    });
  }

  ngOnInit() {
    this.globals.subtractFromLoading();
  }

  get nroProcesso() {
    return this.form.get("nroProcesso");
  }

  buscarPorNroProcesso(form) {
    this.router.navigate(["listar-ordem", form.nroProcesso]);
  }

}
